const translations = {
    updatePilotError: `Unable to update pilot name at this time`
};

export default translations;
